import {useState} from "react";
import {Button, Col, InputGroup} from "react-bootstrap";
import {useAppDispatch, useAppSelector} from "../../../services/hooks";
import {addProduct, UpdateProductQuantityInterface} from "../../../stores/cart/cartSlice";
import {useTranslation} from "react-i18next";

export default function ProductInfoAvailable() {
    const {t} = useTranslation('productPage')
    const dispatch = useAppDispatch()
    const productId = useAppSelector((state) => state.product.data.id)
    const [addingToCart, setAddingToCart] = useState<boolean>(false);
    const [quantity, setQuantity] = useState<number>(1)

    function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
        const value = Number(event.target.value.replace(/\D/g, ''));
        if (value <= 999) handleQuantityChange(Math.max(value, 1));
    }

    const handleQuantityChange = (newQuantity: number) => setQuantity(newQuantity);
    const handleAddToCart = async () => {
        setAddingToCart(true);
        dispatch(addProduct({id: productId, quantity: quantity} as UpdateProductQuantityInterface));

        setTimeout(() => setAddingToCart(false), 3000);
    }

    return (
        <Col xs={12} className="text-center my-3">
            <InputGroup className="w-100">
                <Button variant="dark" className="bi-dash-lg rounded-0 rounded-start-3 w-25"
                        onClick={() => handleQuantityChange(Math.max(quantity - 1, 1))}
                />
                <input data-testid="product_qty" type="number" min={1} max={999} value={quantity} maxLength={4}
                       className="form-control text-center border-dark-subtle focus-ring focus-ring-warning py-3 py-md-2"
                       aria-label="ilość sztuk"
                       onChange={(e) => handleInputChange(e)}
                />
                <Button variant="dark" className="bi-plus-lg rounded-0 rounded-end-3 w-25"
                        onClick={() => handleQuantityChange(Math.min(quantity + 1, 999))}
                />
            </InputGroup>
            <Button data-testid="add_to_cart" variant="success" size="lg"
                    className="rounded-3 my-3 my-md-4 h-50 w-100 shadow-sm"
                    onClick={handleAddToCart} disabled={addingToCart}
            >
                {
                    addingToCart
                        ? <>
                        <span
                            className="spinnerCustom spinnerCustomBefore spinnerCustomXs spinnerCustomWhite loading-spinner mx-auto"
                            aria-hidden="true"/>
                            <span className="loading-text" role="status">&nbsp;Czekaj...</span>
                        </>
                        : <strong className="bi-cart-plus button-text">&nbsp;{t('productInfo.addToCart')}</strong>
                }
            </Button>
        </Col>
    );

    /*return (
        <div className="row ">
            <div className="col-12 text-center my-3 ">
                <div className="input-group w-100">
                    <button className="btn btn-dark bi-dash-lg rounded-start-3 w-25" type="button" id="decreaseBtn"></button>
                    <input type="text" maxLength={4} className="form-control text-center border-dark-subtle focus-ring focus-ring-warning py-3 py-md-2" aria-label="ilość sztuk" id="quantity" value="1" />
                    <button className="btn btn-dark bi-plus-lg rounded-end-3 w-25" type="button" id="increaseBtn"></button>
                </div>
                <button className="btn btn-lg btn-success rounded-3 bi-cart-plus my-3  my-md-4  h-50 w-100 shadow-sm add-cart-prod" data-id="61">
                    <span className="spinnerCustom spinnerCustomBefore spinnerCustomXs spinnerCustomWhite d-none loading-spinner mx-auto" aria-hidden="true"></span>
                    <span className="d-none loading-text" role="status">Czekaj...</span>

                    <strong className="button-text">Do koszyka</strong>
                </button>
            </div>
        </div>
    )*/
}